import type { GlobEnvConfig } from 'framework/types/config'

import { warn } from 'framework/utils/log'
import pkg from '../../package.json'
import { getConfigFileName } from '../../build/getConfigFileName'

export function getCommonStoragePrefix() {
  const { VITE_GLOB_APP_SHORT_NAME } = getAppEnvConfig()
  return `${VITE_GLOB_APP_SHORT_NAME}__${getEnv()}`.toUpperCase()
}

// Generate cache key according to version
export function getStorageShortName() {
  return `${getCommonStoragePrefix()}${`__${pkg.version}`}__`.toUpperCase()
}

export function getAppEnvConfig() {
  const ENV_NAME = getConfigFileName(import.meta.env)

  const ENV = (import.meta.env.DEV
    ? (import.meta.env as unknown as GlobEnvConfig) // Get the global configuration (the configuration will be extracted independently when packaging)
    : window[ENV_NAME as any]) as unknown as GlobEnvConfig

  const {
    VITE_GLOB_APP_TITLE,
    VITE_GLOB_API_URL,
    VITE_GLOB_PMS_API_URL,
    VITE_GLOB_IMS_API_URL,
    VITE_GLOB_WMS_API_URL,
    VITE_GLOB_LANDONG_API_URL,
    VITE_GLOB_APP_SHORT_NAME,
    VITE_GLOB_API_URL_PREFIX,
    VITE_GLOB_UPLOAD_URL,
    VITE_GLOB_OMS_API_URL,
    VITE_GLOB_COPS_API_URL,
    VITE_GLOB_COLLECTOR,
    VITE_GLOB_TXCLOUD_ID,
    VITE_GLOB_SENTRY_KEY,
    VITE_GLOB_SENTRY_DSN,
  } = ENV

  if (!/^[a-zA-Z_]*$/.test(VITE_GLOB_APP_SHORT_NAME)) {
    warn(
      `VITE_GLOB_APP_SHORT_NAME Variables can only be characters/underscores, please modify in the environment variables and re-running.`,
    )
  }

  return {
    VITE_GLOB_APP_TITLE,
    VITE_GLOB_API_URL,
    VITE_GLOB_PMS_API_URL,
    VITE_GLOB_IMS_API_URL,
    VITE_GLOB_WMS_API_URL,
    VITE_GLOB_LANDONG_API_URL,
    VITE_GLOB_APP_SHORT_NAME,
    VITE_GLOB_API_URL_PREFIX,
    VITE_GLOB_UPLOAD_URL,
    VITE_GLOB_OMS_API_URL,
    VITE_GLOB_COPS_API_URL,
    VITE_GLOB_COLLECTOR,
    VITE_GLOB_TXCLOUD_ID,
    VITE_GLOB_SENTRY_KEY,
    VITE_GLOB_SENTRY_DSN,
  }
}

/**
 * @description: Development mode
 */
export const devMode = 'development'

/**
 * @description: Production mode
 */
export const prodMode = 'production'

/**
 * @description: Get environment variables
 * @returns:
 * @example:
 */
export function getEnv(): string {
  return import.meta.env.MODE
}

/**
 * @description: Is it a development mode
 * @returns:
 * @example:
 */
export function isDevMode(): boolean {
  return import.meta.env.DEV
}

/**
 * @description: Is it a production mode
 * @returns:
 * @example:
 */
export function isProdMode(): boolean {
  return import.meta.env.PROD
}
